import React, { useEffect } from 'react';
import { SYS_SPACE_FIXED_300, SYS_SPACE_RELATIVE_4_XL } from '@oneaudi/unified-web-common';
import { useServicesContext } from '../../../../context';
import { Text } from '@oneaudi/unified-web-components';
import { DangerousElement } from '../../../../components';
import { isValidToRender } from './FinanceUtils';
import { readFinance, getValueFromPath } from '../../../utils';
export const FinanceDisclaimerMessages = ({ financing, hideFinancingTable, hideCalculationDisclaimer, interpretDisclaimersTextStyle, position, disclaimerListItems, isPlp, vehicleId, vehicleType, }) => {
    const { getAdditionalService } = useServicesContext();
    const logger = getAdditionalService('s2:logger');
    const [financingInPDP, setFinancingInPDP] = React.useState(undefined);
    useEffect(() => {
        if (!isPlp) {
            const storeName = (vehicleType === null || vehicleType === void 0 ? void 0 : vehicleType.toUpperCase()) === 'N' ? 'VTP_FINANCING_NC' : 'VTP_FINANCING_UC';
            readFinance(storeName)
                .then((result) => {
                var _a;
                const financeResponse = (_a = result === null || result === void 0 ? void 0 : result.financing[vehicleId]) === null || _a === void 0 ? void 0 : _a.financeResponseData;
                setFinancingInPDP(financeResponse);
            })
                .catch((err) => {
                logger === null || logger === void 0 ? void 0 : logger.error(err);
            });
        }
    }, []);
    return (React.createElement(React.Fragment, null, disclaimerListItems &&
        disclaimerListItems.map((disclaimerListItem, index) => {
            const disclaimerName = disclaimerListItem.disclaimerMsgKey;
            const disclaimerMsg = isPlp
                ? financing[disclaimerName]
                : getValueFromPath(financingInPDP, disclaimerListItem.disclaimerMsgPath);
            if (disclaimerMsg &&
                position === disclaimerListItem.disclaimerPositionKey &&
                isValidToRender(disclaimerName, hideFinancingTable, hideCalculationDisclaimer)) {
                return (React.createElement(Text, { key: disclaimerName, tag: "p", variant: {
                        order: '2',
                        style: 'normal',
                        type: 'copy',
                    }, margin: [
                        position === 'Bottom' && index === 1 ? SYS_SPACE_RELATIVE_4_XL : 0,
                        0,
                        position === 'Top' ? SYS_SPACE_FIXED_300 : 0,
                        0,
                    ] }, interpretDisclaimersTextStyle ? (React.createElement(DangerousElement, { as: "span", html: disclaimerMsg, sanitize: false })) : (disclaimerMsg === null || disclaimerMsg === void 0 ? void 0 : disclaimerMsg.replace(/<\/?[^>]+(>|$)/g, ''))));
            }
            return null;
        })));
};
